import { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import INIT_CLIENTS from "./clientsData";

// Shared hook — returns live client list from Firestore
// Falls back to hardcoded list if Firestore is empty
export default function useClients(assignedClients) {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    const q = query(collection(db,"clients"), orderBy("name"));
    const unsub = onSnapshot(q, snap=>{
      if(snap.empty){
        // Firestore not yet imported — fall back to hardcoded list
        setClients(INIT_CLIENTS.map(c=>({...c, firestoreId:null})));
      } else {
        setClients(snap.docs.map(d=>({...d.data(), firestoreId:d.id})));
      }
      setLoading(false);
    }, err=>{
      console.error("useClients error:", err);
      setClients(INIT_CLIENTS.map(c=>({...c, firestoreId:null})));
      setLoading(false);
    });
    return ()=>unsub();
  },[]);

  const filtered = assignedClients
    ? clients.filter(c=>assignedClients.includes(c.name))
    : clients;

  const clientNames = filtered.map(c=>c.name).sort();

  return { clients: filtered, clientNames, loading };
}
